export const TEST_ID = 'itemCardWithBorder';
